var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag ? _vm.htmlTag : 'div',{tag:"component",class:['b-animation'],attrs:{"data-scroll":"","data-scroll-call":_vm.call ? _vm.call : null,"data-scroll-delay":_vm.delay ? _vm.delay : null,"data-scroll-direction":_vm.direction ? _vm.direction : null,"data-scroll-offset":_vm.offset ? _vm.offset : null,"data-scroll-position":_vm.position ? _vm.position : null,"data-scroll-speed":_vm.checkBreakpointUpXl
            ? _vm.speed
                ? _vm.speed
                : null
            : _vm.speedMobile
            ? _vm.speedMobile
            : null}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }